module.exports = __webpack_public_path__ + "media/images/calendar_empty-state-5ad2a2ae.svg";